import React, { useState } from "react"
import { useDrop } from "react-dnd"
import { startTimeAllCases, endTimeAllCases } from "../../../utils/realTimeUtils"

const ItemType = "TASK"

export const DroppableSlot = React.memo(
	({
		index,
		resourceId,
		moveTask,
		editMode,
		topOffset,
		view,
		sandbox,
		isTomorrowMode,
		totalMinutes,
		openTime
	}) => {
		const [taskWidth, setTaskWidth] = useState(null)
		const [hoverTime, setHoverTime] = useState("")

		const isDetailedView = view === "Detailed"
		const propertyCount = isDetailedView || view !== "Minimal" ? 2 : 1
		const taskHeight = 30 * propertyCount

		const [{ isOver }, drop] = useDrop(
			() => ({
				accept: ItemType,
				drop: (item, monitor) => {
					const taskPosition = { x: index, y: topOffset }
					moveTask(item.task, taskPosition, resourceId)
				},
				collect: monitor => ({ isOver: monitor.isOver() }),
				canDrop: () => editMode,
				hover: (item, monitor) => {
					const { startTime, endTime } = {
						startTime: startTimeAllCases(item.task, sandbox, isTomorrowMode),
						endTime: endTimeAllCases(item.task, sandbox, isTomorrowMode)
					}
					const calculatedWidth = ((endTime - startTime) * 100) / totalMinutes
					setTaskWidth(calculatedWidth)

					const tenMinuteIndex = index
					const hours = Math.floor((openTime + tenMinuteIndex * 10) / 60)
					const minutes = (tenMinuteIndex % 6) * 10
					const timeString = `${hours}:${minutes === 0 ? "00" : minutes < 10 ? `0${minutes}` : minutes}`
					setHoverTime(timeString)
				}
			}),
			[editMode]
		)

		return (
			<div
				ref={editMode ? drop : null}
				className={`absolute rounded-md transition-transform duration-100 ease-in-out ${
					isOver ? "bg-gray-200 border-gray-500" : "bg-transparent"
				}`}
				style={{
					top: `${topOffset}px`,
					left: `${index * (100 / (totalMinutes / 10))}%`,
					width: taskWidth ? `${taskWidth}%` : `${100 / (totalMinutes / 10)}%`,
					height: taskHeight,
					zIndex: isOver ? 1000 : "auto"
				}}
			>
				{isOver && (
					<>
						<div
							className="absolute left-0 right-0 top-[-15px] text-xs text-white bg-black px-2 py-1 rounded-md"
							style={{ transform: "translateY(-100%)", zIndex: 1001 }}
						>
							{hoverTime}
						</div>
						<div
							className="absolute left-0 right-0 h-[2px] bg-black"
							style={{ top: "-2px", zIndex: 1001 }}
						/>
					</>
				)}
			</div>
		)
	}
)
